import PropTypes from 'prop-types';

import styles from '@shared/components/organisms/MobileVacationDiv/MobileVacationDiv.module.scss';
export default function MobileVacationDiv({ title, children, showDivider = true }) {
  return (
    <div className={styles.divContainer}>
      <div className={styles.titleContainer}>{title}</div>
      <div className={styles.bodyContainer}>
        <div className={`${styles.subContainer} ${!showDivider ? styles.noDivider : ''}`}>
          <div className={styles.semiContainer}>
            <div className={styles.content}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

MobileVacationDiv.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  showDivider: PropTypes.bool,
};
